// TODO: try to replace with https://unpoly.com/up-validate

up.compiler('[new-record]', (element) => {
  let form = element.closest('form')
  up.validate(form, { target: 'form [reload-on-adding-new-record] ' })
})
